<template>
  <div
    class="hodo-main-menu main-menu menu-fixed menu-accordion menu-shadow"
    :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered),
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light',
    ]"
    @mouseenter="updateMouseHovered(true)"
    @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
        name="header"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        :toggleCollapsed="toggleCollapsed"
        :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto flex items-center navbar-brand">
            <b-link class to="/">
              <span class="brand-logo">
                <b-img :src="logoImg" alt="logo" />
              </span>
            </b-link>

            <div class="ml-1 row">
              <div class="d-flex gap-2 align-items-center w-full">
                <div
                  v-if="!isShowSelect"
                  class="d-flex align-items-center gap-4 mr-1"
                >
                  <h2
                    class="mb-0 text-primary"
                    style="font-size: 18px; width: fit-content"
                  >
                    {{
                      (supplierInfo && supplierInfo.name) ||
                      (processorsInfo && processorsInfo.name)
                    }}
                  </h2>
                  <svg
                    @click.stop="() => (isShowSelect = true)"
                    class="cursor-pointer"
                    width="22"
                    height="22"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.91 15.51H15.38C15.1148 15.51 14.8604 15.6154 14.6729 15.8029C14.4854 15.9904 14.38 16.2448 14.38 16.51C14.38 16.7752 14.4854 17.0296 14.6729 17.2171C14.8604 17.4046 15.1148 17.51 15.38 17.51H17.78C16.6769 18.6627 15.2544 19.4593 13.6952 19.7974C12.1359 20.1355 10.5112 19.9996 9.02978 19.4072C7.54834 18.8149 6.27787 17.7931 5.38159 16.4732C4.48531 15.1532 4.00418 13.5955 4 12C4 11.7348 3.89464 11.4804 3.70711 11.2929C3.51957 11.1054 3.26522 11 3 11C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2.00529 13.9528 2.58222 15.8613 3.6596 17.49C4.73699 19.1187 6.26767 20.3964 8.06274 21.1652C9.85782 21.9341 11.8387 22.1605 13.761 21.8166C15.6833 21.4727 17.4628 20.5735 18.88 19.23V21C18.88 21.2652 18.9854 21.5196 19.1729 21.7071C19.3604 21.8946 19.6148 22 19.88 22C20.1452 22 20.3996 21.8946 20.5871 21.7071C20.7746 21.5196 20.88 21.2652 20.88 21V16.5C20.8775 16.2416 20.7752 15.9943 20.5943 15.8097C20.4135 15.6251 20.1683 15.5177 19.91 15.51ZM15 12C15 11.4067 14.8241 10.8266 14.4944 10.3333C14.1648 9.83994 13.6962 9.45542 13.1481 9.22836C12.5999 9.0013 11.9967 8.94189 11.4147 9.05764C10.8328 9.1734 10.2982 9.45912 9.87868 9.87868C9.45912 10.2982 9.1734 10.8328 9.05764 11.4147C8.94189 11.9967 9.0013 12.5999 9.22836 13.1481C9.45542 13.6962 9.83994 14.1648 10.3333 14.4944C10.8266 14.8241 11.4067 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12ZM11 12C11 11.8022 11.0586 11.6089 11.1685 11.4444C11.2784 11.28 11.4346 11.1518 11.6173 11.0761C11.8 11.0004 12.0011 10.9806 12.1951 11.0192C12.3891 11.0578 12.5673 11.153 12.7071 11.2929C12.847 11.4327 12.9422 11.6109 12.9808 11.8049C13.0194 11.9989 12.9996 12.2 12.9239 12.3827C12.8482 12.5654 12.72 12.7216 12.5556 12.8315C12.3911 12.9414 12.1978 13 12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12ZM12 2C9.43639 2.00731 6.97349 2.99891 5.12 4.77V3C5.12 2.73478 5.01464 2.48043 4.82711 2.29289C4.63957 2.10536 4.38522 2 4.12 2C3.85478 2 3.60043 2.10536 3.41289 2.29289C3.22536 2.48043 3.12 2.73478 3.12 3V7.5C3.12 7.76522 3.22536 8.01957 3.41289 8.20711C3.60043 8.39464 3.85478 8.5 4.12 8.5H8.62C8.88522 8.5 9.13957 8.39464 9.32711 8.20711C9.51464 8.01957 9.62 7.76522 9.62 7.5C9.62 7.23478 9.51464 6.98043 9.32711 6.79289C9.13957 6.60536 8.88522 6.5 8.62 6.5H6.22C7.32247 5.34787 8.74409 4.5515 10.3024 4.21311C11.8607 3.87472 13.4846 4.00975 14.9656 4.60086C16.4466 5.19198 17.7172 6.21221 18.6142 7.5306C19.5113 8.849 19.9938 10.4054 20 12C20 12.2652 20.1054 12.5196 20.2929 12.7071C20.4804 12.8946 20.7348 13 21 13C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2Z"
                      fill="#20409B"
                    />
                  </svg>
                </div>
                <SelectMarket
                  v-show="isShowSelect"
                  :isHiddenLabel="true"
                  classProp=" cs-font-size flex-1"
                  @onChangePharma="() => {}"
                />

                <feather-icon
                  @click.stop="() => (isShowSelect = false)"
                  v-show="isShowSelect"
                  icon="XCircleIcon"
                  size="24"
                  class="text-primary cursor-pointer"
                />
              </div>
            </div>
            <!-- <h5
                class="brand-text"
            >{{ isProcessor ? (processorName || 'Processor Portal') : (supplierName || appName) }}</h5>-->
          </li>

          <!-- Toggler Button -->
          <li v-show="false" class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                icon="XIcon"
                size="20"
                class="d-block d-xl-none"
                @click="toggleVerticalMenuActive"
              />
              <!-- <feather-icon
                :icon="collapseTogglerIconFeather"
                size="20"
                class="d-none d-xl-block collapse-toggle-icon"
                @click="toggleCollapsed"
              />-->
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom" />

    <!-- main menu content-->
    <vue-perfect-scrollbar
      :settings="perfectScrollbarSettings"
      class="main-menu-content scroll-area"
      tagname="ul"
      @ps-scroll-y="
        (evt) => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
        :items="newNavMenu"
        class="navigation navigation-main"
        style="margin-top: 20px"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->

    <!-- <div @click="toggleCollapsed">
      <div>Đóng</div>
    </div>-->
  </div>
</template>

<script>
import SelectMarket from "@/layouts/components/SelectMarket.vue";
import navMenuItems from "@/navigation/vertical";
import appUtils from "@/utils/appUtils";
import useAppConfig from "@core/app-config/useAppConfig";
import { $themeConfig } from "@themeConfig";
import { computed, provide, ref } from "@vue/composition-api";
import { BImg, BLink } from "bootstrap-vue";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";
import { ROLES_SYSTEM } from "../../../../../utils/constant";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";

export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg,
    SelectMarket,
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true,
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      isShowSelect: false,
    };
  },
  computed: {
    ...mapState({
      is_test_provider: (state) => state.authenticate.is_test_provider,
      supplierInfo: (state) => state.authenticate.userLogin?.supplierInfo || {},
      processorsInfo: (state) =>
        state.authenticate.userLogin?.processorsInfo || {},
      partnerFeature: (state) => state.app.partnerFeature || {},
    }),
    newNavMenu() {
      if ([ROLES_SYSTEM.SUPPLIER, ROLES_SYSTEM.SUPPLIER_PRODUCT].includes(1)) {
        // const formatNavMenuItems = this.partnerFeature?.partner_product
        //   ? PARTNER_PRODUCT_MENU
        //   : navMenuItems;
        const formatNavMenuItems = navMenuItems;

        const data = formatNavMenuItems.map((item) => {
          let title = item.title;

          // if (!item.children) {
          //   switch (item.route) {
          //     case 'orders':
          //       title =
          //         this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //           ? this.$t('lbl_orders')
          //           : this.$t('nav_menu.lbl_required_test_manager')
          //       break
          //     case 'inventory':
          //       title =
          //         this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //           ? this.$t('lbl_inventory_product')
          //           : this.$t('nav_menu.lbl_test_inventories')
          //       break
          //     case 'services':
          //       title =
          //         this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //           ? this.$t('lbl_product_category')
          //           : this.$t('nav_menu.lbl_test_list')
          //       break
          //     case 'configs':
          //       title = this.$t('nav_menu.lbl_system_settings')
          //       break
          //   }
          // } else {
          //   const newChildren = item?.children?.map(child => {
          //     let titleChild = child.title
          //     switch (child.route) {
          //       case 'orders':
          //         titleChild =
          //           this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //             ? this.$t('lbl_orders')
          //             : this.$t('nav_menu.lbl_required_test_manager')
          //         break
          //       case 'inventory-service':
          //         titleChild =
          //           this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //             ? this.$t('lbl_inventory_product')
          //             : this.$t('nav_menu.lbl_test_inventories')
          //         break
          //       case 'services':
          //         titleChild =
          //           this.$role === ROLES_SYSTEM.SUPPLIER_PRODUCT
          //             ? this.$t('lbl_product_category')
          //             : this.$t('nav_menu.lbl_test_list')
          //         break
          //       case 'configs':
          //         titleChild = this.$t('nav_menu.lbl_system_settings')
          //         break
          //     }
          //     return {
          //       ...child,
          //       title: titleChild
          //     }
          //   })
          //   item.children = newChildren
          // }

          return {
            ...item,
            title,
          };
        });
        return data;
      } else {
        const data = navMenuItems.map((item) => {
          let title = item.title;
          switch (item.route) {
            case "orders-processor":
              title = this.$t("lbl_required_test_manager");
              break;
          }

          return {
            ...item,
            title,
          };
        });

        return data;
      }
    },
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered,
    } = useVerticalNavMenu(props);

    const { skin } = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false,
    };

    const collapseTogglerIconFeather = computed(() =>
      collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const { appName, appLogoImage } = $themeConfig.app;

    const userData = JSON.parse(localStorage.getItem("user"));
    // const isSupplier = userData?.suppliers?.length;
    const isProcessor = userData?.processors?.length;
    const processorName = userData?.processorsInfo?.name;
    const supplierName = userData?.supplierInfo?.name;

    const logoImg = userData?.supplierInfo?.logo
      ? appUtils.getImageURL(userData?.supplierInfo?.logo)
      : appLogoImage;

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage,
      isProcessor,
      supplierName,
      processorName,
      logoImg,
    };
  },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
.hodo-main-menu {
  display: flex !important;
  flex-direction: column !important;
}
.hodo-main-menu .navbar-header {
  height: auto !important;
  .navbar-brand {
    white-space: normal;
  }
}

.cs-font-size * {
  font-size: 16px;
}
</style>
